import React from 'react';

export const ColorItem = ({ color }) => (
  <div
    className="color-item"
    style={{ backgroundColor: `${color}` }}
  />
);
